"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var isDuringDate = function isDuringDate(beginDateStr, endDateStr) {
  var curDate = new Date();
  var beginDate = new Date(beginDateStr);
  var endDate = new Date(endDateStr);

  if (curDate >= beginDate && curDate <= endDate) {
    return true;
  }

  return false;
};

var isSameDay = function isSameDay(first, second) {
  return first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
};

var _default = {
  isDuringDate: isDuringDate,
  isSameDay: isSameDay
};
exports["default"] = _default;